<template>
  <div class="relative bg-[#0f172a] overflow-x-hidden">
    <main>
      <section class="relative isolate py-24 sm:py-32">

        <!-- Text Section -->
        <div class="mx-auto max-w-4xl px-6 text-center text-white">
           <span class="text-xs tracking-[0.35em] font-semibold text-yellow-400">
            SERVICES
          </span>
          <h1 class="text-4xl mt-6 font-extrabold tracking-tight sm:text-6xl">Our Services</h1>

          <p class="mt-6 text-lg leading-8 text-blue-100">
            Oillead Integrated Services Ventures Limited (OLS) provides comprehensive engineering and project execution services —
            from Concept & FEED to Procurement, Installation, Commissioning,
            Asset Integrity Management, and QHSE Support and Process Services.
          </p>

          <p class="mt-4 text-lg leading-8 text-blue-100">
            Our field services support plant shut-downs, turnarounds, new construction,
            and maintenance projects. We deliver single-source solutions covering
            parts, labor, logistics, and engineering — from tear-down and inspection
            to final assembly and start-up with full QHSE integration.
          </p>

          <div class="mt-10">
              <router-link
          to="/services"
          class="inline-flex items-center gap-2 rounded-full
                     bg-yellow-400 px-7 py-3 text-sm font-semibold text-black
                     shadow-lg hover:bg-yellow-400 hover:scale-105 transition-all">
          View All Services →
        </router-link>
          </div>
        </div>

        <!-- Images Section -->
        <div class="mt-16 mx-auto max-w-7xl px-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-12">

          <!-- Service 1 -->
          <div class="text-center group">
            <img
              src="../assets/ourservices13.png"
              alt="Escape Chute Systems"
              class="w-full h-[400px] sm:h-[450px] md:h-[500px]
                     rounded-2xl object-cover shadow-2xl ring-1 ring-white/10
                     hover:-translate-y-3 hover:scale-[1.03] transition-all duration-300"
            />
            <div class="mt-5">
              <p class="text-lg font-semibold tracking-wide text-white">Escape Chute Systems</p>
              <span class="mt-2 block h-px w-16 mx-auto bg-blue-400/40 group-hover:bg-yellow-400 transition"></span>
            </div>
          </div>

          <!-- Service 2 -->
          <div class="text-center group">
            <img
              src="../assets/ourservices10.jpeg"
              alt="Procurement & Supply Chain"
              class="w-full h-[400px] sm:h-[450px] md:h-[500px]
                     rounded-2xl object-cover shadow-2xl ring-1 ring-white/10
                     hover:-translate-y-3 hover:scale-[1.03] transition-all duration-300"
            />
            <div class="mt-5">
              <p class="text-lg font-semibold tracking-wide text-white">Procurement & Supply Chain</p>
              <span class="mt-2 block h-px w-16 mx-auto bg-blue-400/40 group-hover:bg-yellow-400 transition"></span>
            </div>
          </div>

          <!-- Service 3 -->
          <div class="text-center group">
            <img
              src="../assets/ourservices9.jpeg"
              alt="Pipeline Construction"
              class="w-full h-[400px] sm:h-[450px] md:h-[500px]
                     rounded-2xl object-cover shadow-2xl ring-1 ring-white/10
                     hover:-translate-y-3 hover:scale-[1.03] transition-all duration-300"
            />
            <div class="mt-5">
              <p class="text-lg font-semibold tracking-wide text-white">Pipeline Construction</p>
              <span class="mt-2 block h-px w-16 mx-auto bg-blue-400/40 group-hover:bg-yellow-400 transition"></span>
            </div>
          </div>

          <!-- Service 4 -->
          <div class="text-center group">
            <img
              src="../assets/ourservices8.png"
              alt="Offshore Installations & Support"
              class="w-full h-[400px] sm:h-[450px] md:h-[500px]
                     rounded-2xl object-cover shadow-2xl ring-1 ring-white/10
                     hover:-translate-y-3 hover:scale-[1.03] transition-all duration-300"
            />
            <div class="mt-5">
              <p class="text-lg font-semibold tracking-wide text-white">Offshore Installations & Support</p>
              <span class="mt-2 block h-px w-16 mx-auto bg-blue-400/40 group-hover:bg-yellow-400 transition"></span>
            </div>
          </div>

          <!-- Service 5 -->
          <div class="text-center group">
            <img
              src="../assets/ourservices4.png"
              alt="Engineering"
              class="w-full h-[400px] sm:h-[450px] md:h-[500px]
                     rounded-2xl object-cover shadow-2xl ring-1 ring-white/10
                     hover:-translate-y-3 hover:scale-[1.03] transition-all duration-300"
            />
            <div class="mt-5">
              <p class="text-lg font-semibold tracking-wide text-white">Engineering</p>
              <span class="mt-2 block h-px w-16 mx-auto bg-blue-400/40 group-hover:bg-yellow-400 transition"></span>
            </div>
          </div>

          <!-- Service 6 -->
          <div class="text-center group">
            <img
              src="../assets/ourservices12.jpg"
              alt="Battery Energy Storage Systems"
              class="w-full h-[400px] sm:h-[450px] md:h-[500px]
                     rounded-2xl object-cover shadow-2xl ring-1 ring-white/10
                     hover:-translate-y-3 hover:scale-[1.03] transition-all duration-300"
            />
            <div class="mt-5">
              <p class="text-lg font-semibold tracking-wide text-white">Battery Energy Storage Systems</p>
              <span class="mt-2 block h-px w-16 mx-auto bg-blue-400/40 group-hover:bg-yellow-400 transition"></span>
            </div>
          </div>

        </div>
      </section>
    </main>
  </div>
</template>